export default __webpack_public_path__ + "static/icon-33-4-e410b351d6e84a858e46dab351d0aaa3.png";